module.exports = __webpack_public_path__ + "static/media/image-5.6469cbc4.png";